import { Box, Typography } from '@mui/material'
import { Colors } from '~/libs/mui/theme'
import { Video } from '~/types/api/videos'
import { VideoListItemThumbnail } from './VideoListItemThumbnail'

interface VideoListItemMainProps {
  video: Video
}

export function VideoListItemMain({ video }: VideoListItemMainProps): JSX.Element {
  const { title, description, creator } = video
  return (
    <Box>
      <Box display='flex' flexDirection={{ xs: 'row', sm: 'column', lg: 'row' }} gap='8px'>
        <Box flexShrink={1}>
          <VideoListItemThumbnail width={150} video={video} />
        </Box>
        <Box display='flex' flexDirection='column' justifyContent='space-between' padding='4px'>
          <Typography variant='h2' color={Colors.colorD7D9DB}>
            {title}
          </Typography>
          <Box sx={{ display: { sm: 'none' } }}>
            <Typography fontSize={12} color={Colors.colorD7D9DB}>
              {creator?.name}
            </Typography>
          </Box>
          <Box mt={1} sx={{ display: { xs: 'none', sm: 'block' } }}>
            <Description>{description}</Description>
          </Box>
        </Box>
      </Box>
      <Box mt={1} sx={{ display: { xs: 'block', sm: 'none' } }}>
        <Description>{description}</Description>
      </Box>
    </Box>
  )
}

function Description({ children }: { children: React.ReactNode }) {
  return (
    <Typography
      fontSize='11px'
      color={Colors.color8c8c8c}
      lineHeight='16px'
      maxHeight={'48px'}
      sx={{
        wordWrap: 'break-word',
        overflow: 'hidden',
        display: '-webkit-box',
        WebkitLineClamp: 3,
        lineClamp: 3,
        WebkitBoxOrient: 'vertical',
      }}
    >
      {children}
    </Typography>
  )
}
